import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field } from "formik";
import Alert from "react-s-alert";
import { styled } from "../../theme";
import { FlexRow } from "../../box";
import { FieldError } from "../atoms/field-error";
import { FieldLabel } from "../atoms/FieldLabel";
import { LockIcon } from "../atoms/LockIcon";
import { SnapshotControl } from "../atoms/snapshot-control";
import { imageOfSupportedMimeType, readFilesAsBase64 } from "./utils";
/**
 * A formik field for capturing and displaying snapshots.
 *
 * @param {Props} props The props for the component.
 * @returns {JSX.Element} The rendered snapshot control field component.
 */
export const SnapshotControlField = ({ label, name, disabled, textSize, transformUrl, loadImageFiles, }) => {
    const setImage = (form) => async (event) => {
        const fileArray = Array.from(event.currentTarget.files);
        if (!fileArray.every(imageOfSupportedMimeType)) {
            Alert.error("Unsupported media type for uploaded file");
            return;
        }
        const normalizedFileArray = await loadImageFiles(fileArray);
        const files = await readFilesAsBase64(normalizedFileArray);
        form.setFieldValue(name, files[0], true);
        form.setFieldTouched(name, true, true);
    };
    return (_jsx(Field, { name: name, children: ({ field, form }) => {
            return (_jsxs(Wrapper, { children: [_jsxs(FlexRow, { children: [_jsx(FieldLabel, { disabled: disabled, children: label }), disabled && _jsx(LockIcon, {})] }), _jsx(SnapshotControl, { name: name, image: field.value, disabled: disabled, textSize: textSize, onClear: () => {
                            form.setFieldValue(name, "", true);
                            form.setFieldTouched(name, true, true);
                        }, onChange: setImage(form), transformUrl: transformUrl }), _jsx(FieldError, { name: name })] }));
        } }));
};
const Wrapper = styled.div `
  margin: 0.625em 0;
`;
